// First-party analytics enrichment for the public site.
// Server records pageviews via after_action; this module adds:
//   - page duration on visibilitychange/pagehide via sendBeacon
//   - tel:/mailto: click goals
//   - [data-track] custom goals
// All requests go to POST /analytics/events.
// Server skips logged-in staff and bots.

(function () {
    // Bot probe: if sessionStorage is unavailable, do nothing.
    try {
        sessionStorage.setItem("an_probe", "1");
        sessionStorage.removeItem("an_probe");
    } catch (e) {
        return;
    }

    var ENDPOINT = "/analytics/events";
    var pageStart = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
    var sentDuration = false;

    function post(payload) {
        try {
            var body = JSON.stringify(payload);
            if (navigator.sendBeacon) {
                var blob = new Blob([body], { type: "application/json" });
                navigator.sendBeacon(ENDPOINT, blob);
            } else if (window.fetch) {
                fetch(ENDPOINT, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: body,
                    keepalive: true,
                    credentials: "same-origin"
                }).catch(function () { });
            }
        } catch (e) {
            // swallow
        }
    }

    function track(name, kind, properties) {
        post({
            name: name,
            kind: kind || "custom",
            properties: properties || {},
            occurred_at_ms: Date.now()
        });
    }

    function sendDuration() {
        if (sentDuration) return;
        sentDuration = true;
        var elapsed = (typeof performance !== "undefined" && performance.now)
            ? Math.round(performance.now() - pageStart)
            : Math.round(Date.now() - pageStart);
        post({
            name: "pageview_duration",
            kind: "pageview_duration",
            duration_ms: elapsed,
            occurred_at_ms: Date.now()
        });
    }

    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") sendDuration();
    });
    window.addEventListener("pagehide", sendDuration);

    // Engagement: fire once per tab when the user shows real interest.
    // Triggers: ≥3s dwell, scroll past 100px, or any click.
    var ENGAGED_KEY = "_an_engaged";
    var engagedSent = false;
    try { engagedSent = sessionStorage.getItem(ENGAGED_KEY) === "1"; } catch (e) { }

    function markEngaged(reason) {
        if (engagedSent) return;
        engagedSent = true;
        try { sessionStorage.setItem(ENGAGED_KEY, "1"); } catch (e) { }
        post({ name: "engagement", kind: "custom", properties: { reason: reason }, occurred_at_ms: Date.now() });
        removeEngagementListeners();
    }

    function onEngagementScroll() {
        if ((window.scrollY || window.pageYOffset || 0) > 100) markEngaged("scroll");
    }
    function onEngagementClick() { markEngaged("click"); }
    var engagementTimer = null;

    function removeEngagementListeners() {
        window.removeEventListener("scroll", onEngagementScroll);
        document.removeEventListener("click", onEngagementClick, true);
        if (engagementTimer) { clearTimeout(engagementTimer); engagementTimer = null; }
    }

    if (!engagedSent) {
        window.addEventListener("scroll", onEngagementScroll, { passive: true });
        document.addEventListener("click", onEngagementClick, true);
        engagementTimer = setTimeout(function () { markEngaged("dwell"); }, 3000);
    }

    // Single delegated click listener for goals.
    document.addEventListener("click", function (event) {
        var el = event.target;
        if (!el || !el.closest) return;

        var anchor = el.closest("a");
        if (anchor && anchor.href) {
            if (anchor.href.indexOf("tel:") === 0) {
                track("phone_click", "goal", { href: anchor.href, text: (anchor.textContent || "").trim().slice(0, 200) });
            } else if (anchor.href.indexOf("mailto:") === 0) {
                track("email_click", "goal", { href: anchor.href, text: (anchor.textContent || "").trim().slice(0, 200) });
            }
        }

        var trackable = el.closest("[data-track]");
        if (trackable) {
            var name = trackable.getAttribute("data-track");
            if (name) {
                var props = {};
                for (var i = 0; i < trackable.attributes.length; i++) {
                    var a = trackable.attributes[i];
                    if (a.name.indexOf("data-track-") === 0) {
                        props[a.name.slice("data-track-".length)] = a.value;
                    }
                }
                track(name, "goal", props);
            }
        }
    }, true); // capture so it runs even if other listeners stopPropagation
})();
